import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentstModule } from '../../shared/components/components.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MonitoramentoComponent } from './monitoramento.component';
import { MonitoramentoRoutingModule } from './monitoramento-routing.module';
import { AgendaFinanceiraComponent } from './agenda-financeira/agenda-financeira.component';
import { LogAgendaFinanceiraComponent } from './agenda-financeira/log-agenda-financeira/log-agenda-financeira.component';

@NgModule({
  imports: [
    CommonModule,
    MonitoramentoRoutingModule,
    NbCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    ComponentstModule,
    CurrencyMaskModule, 
  ],
  exports: [
    MyDatePickerModule,
  ],
  entryComponents: [       
  ],
  declarations: [
    MonitoramentoComponent, 
    AgendaFinanceiraComponent, 
    LogAgendaFinanceiraComponent,
   
  ],
})

export class MonitoramentoModule { }
